import { useState } from "react";
import placeholder from "../assets/mike-profile.png";
import { CardHeader, CardContent, CardTitle, CardDescription, TransparentCard } from "../components/ui/card";
import PageWithNavbar from "@/components/PageWithNavbar";

const AboutPage = () => {
  const [expanded, setExpanded] = useState<string | null>("company");

  return (
    <PageWithNavbar>
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="mx-auto text-left mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mx-auto text-left">
            Founded for <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">Traders</span>
          </h1>
          <p className="text-xl text-muted-foreground mt-2" >
            Created for high-performance, high-fidelity account management and trading.
          </p>
        </div>
        <div className="flex flox-row">
          <button
            className="w-full max-w-xl mx-auto mb-2 py-3 px-6 rounded text-primary text-white font-bold text-xl hover:bg-secondary/80 transition"
            onClick={() => setExpanded(expanded === "company" ? null : "company")}
            aria-expanded={expanded === "company"}
          >
            About the Company
          </button>
          <button
            className="w-full max-w-xl mx-auto mb-2 py-3 px-6 rounded text-primary text-white font-bold text-xl hover:bg-secondary/80 transition"
            onClick={() => setExpanded(expanded === "creator" ? null : "creator")}
            aria-expanded={expanded === "creator"}
          >
            About the Creator
          </button>
        </div>
        <div className="flex flex-col gap-8 justify-left items-stretch h-auto">
          {expanded === "company" && (
            <TransparentCard className="w-full p-0 flex-1 h-full">
              <CardHeader>
                <CardTitle className="text-center text-3xl font-bold mb-2">Doyen Trading Company</CardTitle>
                <CardDescription className="text-center"><a href="https://1130lab.com" className="underline">1130 Lab, LLC</a> — New York, USA</CardDescription>
              </CardHeader>
              <CardContent className="flex flex-col items-center">
                <div className="w-full rounded-lg overflow-hidden">
                  <iframe
                    title="Company Headquarters Map"
                    src="https://www.openstreetmap.org/export/embed.html?bbox=-73.7562%2C42.6526%2C-73.7562%2C42.6526&amp;layer=mapnik&amp;marker=42.6526%2C-73.7562"
                    style={{ width: '100%', height: '340px', border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div>
                <p className="mt-4 text-center">
                  Doyen is developed and maintained by <strong>1130 Lab, LLC</strong>, a New York-based company focused on building innovative software solutions. 
                </p>
                <p className="mt-4 text-center">
                  Our mission is to build the best software available for its intended purpose. No bloat, no unnecessary features, no excessive monetization.
                </p>
                <p className="mt-4 mb-4 text-center">
                  We are dedicated to the craft of software engineering.
                </p>
                </div>
                <p className="text-muted-foreground text-center">
                  P.O Box: 54 State Street, STE 804 Albany, NY, 12207<br />
                  Email: <a href="mailto:mike@1130lab.com" className="underline">mike@1130lab.com</a>
                </p>
              </CardContent>
            </TransparentCard>
          )}
          {expanded === "creator" && (
            <TransparentCard className="w-full p-0 flex-1">
              <CardHeader>
                <CardTitle className="text-center text-3xl font-bold mb-2">About the Creator</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-col items-center mx-auto">
                  <img
                    src={placeholder}
                    alt="Mike McCabe"
                    className="rounded-full w-36 h-36 object-cover mb-6 border-4 border-primary"
                  />
                  <span className="font-semibold">Michael W. McCabe</span>
                  <span className="text-muted-foreground">Founder & Lead Developer</span>
                </div>
                <div>
                  <span className="font-semibold text-left">
                    Background
                  </span>
                  <p className="text-lg text-muted-foreground mb-2 text-left">
                    Before 1130 Lab, I was a quantitative trader in Chicago following nearly a decade in software engineering at companies such as DraftKings and Empyrean Solutions. After years of building software and trading systems, I decided to start my own company to build software I believe in. 
                    </p>
                  <p className="text-lg text-muted-foreground mb-2 text-left">
                    During my time as a trader I witnessed a technology, regulatory and information gap between professional and retail market participants. There is an inherent edge that comes from software such as Doyen. Perhaps it's my Irish roots, but I wish to do my part in leveling the playing field, and letting traders sink or swim based on their ability -- not an inherent disadvantage.
                  </p>
                  <span className="font-semibold text-left">
                    Creating Doyen
                  </span>
                  <p className="text-lg text-muted-foreground mb-2 text-left">
                    Doyen was created to fill a gap in the market for reliable, high-performance trading software tailored to the needs of serious cryptocurrency traders.
                    Professional traders use software like this on a daily basis, and the equities market has a rich ecosystem of tools and platforms available. However, the cryptocurrency market has been underserved in this regard, and I wanted to change that.
                  </p>
                  <p className="text-lg text-muted-foreground mb-2 text-left">
                    I began building Doyen after having developed an automated market maker. The necessities of this AMM is what the algorithmic trading API and Drasil infrastructure is based on. 
                    With so many interfaces and accounts to manage it became clear I needed trading software to better manage my positions, and so the early stages of Doyen were developed.
                    Over time this application evolved. Seeing the lack of any existing software similar to this out in the market, I polished it up and turned it into Doyen.
                  </p>
                </div>
              </CardContent>
            </TransparentCard>
          )}
        </div>
      </div>
    </div>
    </PageWithNavbar>
  );
};

export default AboutPage;
